import React, { ReactElement } from 'react';
import Card from '../card/card.component';
import useStylesListItemSummary from './list-item-summary.styles';

const ListItemSummary: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    children,
  } = props;

  const { classes } = useStylesListItemSummary();

  return (
    <Card isFlat className={classes.listItemSummary}>
      {children}
    </Card>
  );
});

export default ListItemSummary;
